export default __webpack_public_path__ + "static/media/375afbc5f883baaf4f259e0d9a3f27b9.png";